import GridPage from "../MillOrder/GridPage";

export default [
  {
    name: "MillOrders",
    parent: "root",
    url: "/loads/:loadId/millorder?viewState&breadcrumbStack&customerId&customerPOId",
    params: {
      loadId: { type: "string", raw: true },
      customerId: { type: "string", dynamic: true, raw: true },
      customerPOId: { type: "string", dynamic: true, raw: true },
      breadcrumbStack: { type: "string", array: true, dynamic: true },
      viewState: { type: "string", dynamic: true }
    },
    component: GridPage,
    defaultBreadcrumbItems: [
      { to: "home", label: "breadcrumb.customers", icon: "home" },
      { to: "CustomerPurchaseOrders", label: "CustomerPurchaseOrders" },
      { to: "OrderPage", label: "OrderPage" },
      { to: "MillOrders", label: "MillOrders" }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/components/Router/millOrderStates.js